export const BUSINESS_ACCOUNT_INVITE_MODAL = 'BUSINESS_ACCOUNT_INVITE_MODAL'
